import useTranslate from 'modules/local/useTranslate'
import React, {useCallback} from 'react'
import {NullAsDefault} from 'views/Shared'
import _ from 'lodash'
import {SelectCountries} from '../../../Organization/Settings/SelectCountries'
import {useAppConfig} from '../../../../modules/local/AppConfigContext'
import {FilterStatusBar} from '../../../../components/Filters/FilterStatusBar'
import {profileCategories} from '../../Profile/consts/profileCategories'
import {Chip, SectionLabel} from './DirectoryFilterUI'
import {FeastStates} from '../../appFieldTypes'
import {SelectWidget} from '../../custom/ReactSelectComponents'

const feastStateOptions = [
    FeastStates.SAINT,
    FeastStates.BLESSED,
    FeastStates.VENERABLE,
    FeastStates.SERVANT_OF_GOD,
]

const defaultFilter = {
    keyword: undefined,
    country_id: undefined,
    feast_state: undefined,
    position_title: undefined,
}

export const DirectoryProfileFilter = ({
                                            value: filter = defaultFilter,
                                            onChange: setValues = NullAsDefault,
                                        }) => {
    const t = useTranslate()
    const {countries = []} = useAppConfig('countries')
    const {position_titles = []} = useAppConfig('position_titles')

    const handleChange = useCallback(
        (name, value) => setValues({...filter, [name]: value}),
        [filter]
    )

    const filteredParams = Object.entries(filter)
        .filter(([key, value]) => value != null && (key === 'country_id' ? Number(value) !== 0 : true))
        .map(([key, value]) => {
            if (key === 'country_id') {
                return {key, value, displayValue: _.find(countries, {id: Number(value)})?.common_name}
            }
            if (key === 'feast_state') {
                const state = _.find(feastStateOptions, {value})
                return {key, value, displayValue: state ? t(state.label) : value}
            }
            if (key === 'position_title') {
                return {key, value, displayValue: t(value)}
            }
            const category = _.find(profileCategories, {value: key})
            if (category) return {key, value, displayValue: t(category.label)}
            return {key, value, displayValue: value}
        })

    return (
        <div className="flex flex-col gap-3">
            <FilterStatusBar
                filteredParams={filteredParams}
                onClear={() => setValues(defaultFilter)}
                onRemove={(param) => handleChange(param, undefined)}
            />

            <div className="flex flex-col gap-1">
                <SectionLabel>{t('profile')}</SectionLabel>
                <div className="flex flex-wrap gap-1.5">
                    {profileCategories.map((category) => (
                        <Chip
                            key={category.value}
                            active={Number(filter?.[category.value]) === 1}
                            onClick={() => handleChange(category.value, Number(filter?.[category.value]) === 1 ? undefined : 1)}>
                            {t(category.label)}
                        </Chip>
                    ))}
                </div>
            </div>

            <div className="flex flex-col gap-1">
                <SectionLabel>{t('feast state')}</SectionLabel>
                <div className="flex flex-wrap gap-1.5">
                    {feastStateOptions.map((state) => (
                        <Chip
                            key={state.value}
                            active={filter?.feast_state === state.value}
                            onClick={() => handleChange('feast_state', filter?.feast_state === state.value ? undefined : state.value)}>
                            {t(state.label)}
                        </Chip>
                    ))}
                </div>
            </div>

            <div className="flex flex-col gap-1">
                <SectionLabel>{t('position title')}</SectionLabel>
                <SelectWidget
                    allowClear={true}
                    showSearch={true}
                    className="w-full"
                    value={filter?.position_title || undefined}
                    placeholder={t('click to select')}
                    optionFilterProp="children"
                    filterOption={(input, option) =>
                        option.value.toLowerCase().includes(input.toLowerCase()) || option.translated.toLowerCase().includes(input.toLowerCase())
                    }
                    onChange={(value) => handleChange('position_title', value || undefined)}
                    options={position_titles.map((e) => ({
                        value: e.name,
                        translated: t(e.name),
                        label: t(e.name),
                    }))}
                />
            </div>

            <div className="flex flex-col gap-1">
                <SectionLabel>{t('place of residence')}</SectionLabel>
                <SelectCountries
                    value={filter?.country_id || undefined}
                    allowClear={true}
                    onChange={(value) => handleChange('country_id', Number(value) || undefined)}
                    placeholder={t('click to select')}
                />
            </div>
        </div>
    )
}

export default DirectoryProfileFilter
